import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';

import type { GetPacksScoreResponse } from 'app/typings/core/extranet/inventory/packsScores';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '..';

export function usePacksScores(hotelId?: number) {
  return useQuery<GetPacksScoreResponse | null>({
    queryKey: [CORE_QUERY_KEYS.packScore, { hotelId }],
    queryFn: () =>
      hotelId
        ? (apiRequest({
            path: ENDPOINTS.getPackScore,
            params: { hotelId: hotelId.toString() },
          }) as Promise<GetPacksScoreResponse>)
        : Promise.resolve(null),
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
    enabled: !!hotelId,
  });
}
